export default "__VITE_ASSET__DTJqWxg___"